import React, { useState } from 'react'
import { Card, Alert, message } from 'antd'
import BookingFinalize from '../../../../Bookings/components/Search Engine Components/FinalizeAppointment'

const BookingFinalization = ({ bookingDetails, setBookingDetails, onAfterSuccessfulBooking, patient, setLoading }) => {
  const [bookingError, setBookingError] = useState(null)

  // Don't render if booking details are invalid
  if (!bookingDetails) {
    return (
      <Card
        title='Complete Booking'
        bordered={false}
        size='small'
        style={{ boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}
        headStyle={{ padding: '6px 10px', fontSize: '13px' }}
        bodyStyle={{ padding: '8px 10px' }}
      >
        <Alert
          message='Invalid Booking Data'
          description='Please check all required fields are filled correctly.'
          type='warning'
          showIcon
        />
      </Card>
    )
  }

  // Check if clinic reference is missing and show warning
  if (!bookingDetails.clinicRef) {
    return (
      <Card
        title='Complete Booking'
        bordered={false}
        size='small'
        style={{ boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}
        headStyle={{ padding: '6px 10px', fontSize: '13px' }}
        bodyStyle={{ padding: '8px 10px' }}
      >
        <Alert
          message='Missing Clinic Reference'
          description='No clinic is configured for this booking. Please contact your administrator to configure clinic settings.'
          type='error'
          showIcon
        />
      </Card>
    )
  }

  // Enhanced success callback with error handling
  const handleSuccessfulBooking = (...args) => {
    try {
      setBookingError(null)
      onAfterSuccessfulBooking(...args)
    } catch (error) {
      console.error('Error in success callback:', error)
      setBookingError(error.message || 'Error completing booking')
    }
  }

  // Enhanced booking details setter with validation
  const handleSetBookingDetails = (details) => {
    try {
      setBookingDetails(details)
    } catch (error) {
      console.error('Error updating booking details:', error)
      setBookingError(error.message || 'Error updating booking details')
    }
  }

  return (
    <Card
      title='Complete Booking'
      bordered={false}
      size='small'
      style={{ boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}
      headStyle={{ padding: '6px 10px', fontSize: '13px' }}
      bodyStyle={{ padding: '8px 10px' }}
    >
      {bookingError && (
        <Alert
          message='Booking Error'
          description={bookingError}
          type='error'
          showIcon
          style={{ marginBottom: 16 }}
          closable
          onClose={() => setBookingError(null)}
        />
      )}

      <div
        onError={(error) => {
          console.error('Error in BookingFinalize component:', error)
          setBookingError('An error occurred during booking. Please try again.')
          message.error('Booking failed. Please check the console for details.')
        }}
      >
        <BookingFinalize
          setBookingDetails={handleSetBookingDetails}
          bookingDetails={bookingDetails}
          onAfterSuccessfulBooking={handleSuccessfulBooking}
          isHomeVisit={false}
          isVirtualVisit={false}
          patient={patient}
          setReceptionLoadIndicator={setLoading}
          isReceptionBooking={true}
        />
      </div>
    </Card>
  )
}

export default BookingFinalization
